import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Button, Form as BootstrapForm } from 'react-bootstrap';
import './styles.css';
import { FaChevronDown, FaWindowClose, FaFile, FaTimes } from 'react-icons/fa';
import FormularioTarefas from '../FormularioTarefas';
const MAX_CHAR = 32000;
const EXTENSOES_PERMITIDAS = ['.pdf', '.jpg', '.jpeg', '.png'];
const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export default function Anotacao({
  onSubmit,
  initialValues,
  salvandoDados,
  closeModal,
  exibirTarefa = false,
  readOnly,
  hiddenSubmit,
  permitirAnexo = false,
}) {
  const [exibirBlocoTarefa, setExibirBlocoTarefa] = useState(exibirTarefa);
  const [tarefaIncluida, setTarefaIncluida] = useState(false);
  const [tarefaValues, setTarefaValues] = useState({
    descricao: '',
    data: '',
    prioridade: '',
    situacao: '',
    tipoResponsavel: '',
    responsavel: '',
    lembreteEmail: '',
  });
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [erroArquivo, setErroArquivo] = useState('');

  const validationSchema = Yup.object().shape({
    descricao: Yup.string()
      .required(
        exibirBlocoTarefa
          ? 'Preencha os campos do formulário de tarefas'
          : `A descrição é obrigatória.`
      )
      .max(
        MAX_CHAR,
        `A descrição pode conter no máximo ${MAX_CHAR} caracteres.`
      ),
  });

  const handleSubmit = values => {
    if (tarefaIncluida) {
      onSubmit({
        ...values,
        tarefaInternaValues: tarefaValues,
        arquivo: arquivoSelecionado,
      });
      return;
    }
    onSubmit({ ...values, arquivo: arquivoSelecionado });
  };

  const handleSubmitTarefa = values => {
    setTarefaValues(values);
    setTarefaIncluida(true);
  };

  const closeBlocoTarefa = () => {
    setExibirBlocoTarefa(false);
    setTarefaIncluida(false);
    setTarefaValues('');
  };

  const handleFileChange = event => {
    const file = event.target.files[0];
    setErroArquivo('');

    if (!file) {
      setArquivoSelecionado(null);
      return;
    }

    const extensao =
      '.' +
      file.name
        .split('.')
        .pop()
        .toLowerCase();
    if (!EXTENSOES_PERMITIDAS.includes(extensao)) {
      setErroArquivo(
        `Extensão não permitida. Use: ${EXTENSOES_PERMITIDAS.join(', ')}`
      );
      setArquivoSelecionado(null);
      event.target.value = '';
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setErroArquivo('Arquivo muito grande. Tamanho máximo: 10MB');
      setArquivoSelecionado(null);
      event.target.value = '';
      return;
    }

    setArquivoSelecionado(file);
  };

  const removerArquivo = () => {
    setArquivoSelecionado(null);
    setErroArquivo('');
  };

  return (
    <div className="p-2 w-100" style={{ maxWidth: '100%' }}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={values => {
          handleSubmit(values);
        }}
      >
        {({ setFieldValue, isSubmitting, values, errors, touched }) => (
          <Form>
            <BootstrapForm.Group className="mb-3" controlId="descricao">
              <BootstrapForm.Label className="label-form-anotacao">
                Descrição
              </BootstrapForm.Label>
              <Field
                as="textarea"
                name="descricao"
                rows={6}
                maxLength={MAX_CHAR}
                className="form-control"
                style={{ resize: 'vertical', fontSize: 16 }}
                isInvalid={errors.descricao}
                disabled={readOnly}
              />
              <div className="text-muted small mt-1 ">
                A descrição pode conter no máximo {MAX_CHAR} caracteres.
              </div>
            </BootstrapForm.Group>
            {(Object.keys(errors).length > 0 ||
              values.descricao.trim() == '' ||
              Object.keys(touched).length === 0) &&
              !hiddenSubmit && (
                <div className="text-danger small my-2">
                  Preencha o campo de descrição
                </div>
              )}

            {permitirAnexo && !hiddenSubmit && (
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label className="label-form-anotacao">
                  Anexo (opcional)
                </BootstrapForm.Label>
                <BootstrapForm.Control
                  type="file"
                  onChange={handleFileChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                  disabled={readOnly}
                />
                <BootstrapForm.Text className="text-muted">
                  Formatos aceitos: PDF, JPG, JPEG, PNG (máx. 10MB)
                </BootstrapForm.Text>

                {erroArquivo && (
                  <div className="text-danger small mt-1">{erroArquivo}</div>
                )}

                {arquivoSelecionado && (
                  <div className="mt-2">
                    <div
                      className="d-flex align-items-center bg-light rounded p-2"
                      style={{ backgroundColor: '#e7f3ff' }}
                    >
                      <FaFile className="text-primary mr-2" />
                      <span className="flex-grow-1 small">
                        {arquivoSelecionado.name}
                      </span>
                      <small className="text-muted mr-2">
                        ({(arquivoSelecionado.size / 1024).toFixed(1)} KB)
                      </small>
                      <Button
                        variant="link"
                        size="sm"
                        className="p-0 text-danger"
                        onClick={removerArquivo}
                        title="Remover"
                        disabled={readOnly}
                      >
                        <FaTimes />
                      </Button>
                    </div>
                  </div>
                )}
              </BootstrapForm.Group>
            )}

            {!hiddenSubmit && exibirTarefa && (
              <>
                <div className="mb-3">
                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded"
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                    }}
                    onClick={() => setExibirBlocoTarefa(!exibirBlocoTarefa)}
                  >
                    <div className="d-flex align-items-center">
                      <span
                        style={{
                          color: '#495057',
                          fontWeight: '500',
                          fontSize: '14px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Vincular a uma tarefa
                      </span>
                    </div>
                    <div
                      style={{
                        transform: exibirBlocoTarefa
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <FaChevronDown
                        style={{ color: '#6c757d', fontSize: '12px' }}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      maxHeight: exibirBlocoTarefa ? '1000px' : '0px',
                      overflow: exibirBlocoTarefa ? 'visible' : 'hidden',
                      transition: 'max-height 0.3s ease-in-out',
                      backgroundColor: '#fff',
                      border: exibirBlocoTarefa ? '1px solid #e9ecef' : 'none',
                      borderRadius: '0 0 0.375rem 0.375rem',
                      position: 'relative',
                      zIndex: 99998,
                    }}
                  >
                    {exibirBlocoTarefa && (
                      <div
                        className="p-3"
                        style={{ position: 'relative', zIndex: 99999 }}
                      >
                        <FormularioTarefas
                          onSubmit={handleSubmitTarefa}
                          initialValues={tarefaValues}
                          salvandoDados={salvandoDados}
                          closeModal={closeBlocoTarefa}
                          modoInternoDaAnotacao={{
                            exibir: exibirBlocoTarefa,
                            incluido: tarefaIncluida,
                          }}
                          modoEdicao={true}
                          readOnly={tarefaIncluida}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {exibirBlocoTarefa && !tarefaIncluida && (
                  <div className="text-danger small my-2">
                    Preencha os campos do formulário de Tarefa
                  </div>
                )}
              </>
            )}

            {!hiddenSubmit && (
              <>
                <hr className="my-4"></hr>
                <div className="d-flex justify-content-end mt-4">
                  <Button
                    type="submit"
                    className="btn-light-color"
                    size="sm"
                    disabled={
                      isSubmitting ||
                      salvandoDados ||
                      Object.keys(errors).length > 0 ||
                      Object.keys(touched).length === 0 ||
                      values.descricao.trim() == '' ||
                      (exibirBlocoTarefa && !tarefaIncluida) ||
                      readOnly
                    }
                  >
                    Salvar
                  </Button>

                  <Button
                    variant="light"
                    size="sm"
                    type="button"
                    className="d-inline-flex align-items-center ml-2"
                    onClick={() => {
                      closeModal();
                    }}
                    disabled={salvandoDados}
                  >
                    <FaWindowClose />
                    <span className="ml-2 d-xs-none">Fechar</span>
                  </Button>
                </div>
              </>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
}
